import React from 'react';
import { string } from 'prop-types';

const MorningIcon = ({
  color = 'border6-color',
  fontSize = 'var(--base-medium)',
  className = ''
}) => (
  <span
    style={{
      color: `var(--${color})`,
      fontSize: fontSize
    }}
    className={`icon-ic_sunrise ${className}`}
  />
);

MorningIcon.propTypes = {
  color: string,
  fontSize: string,
  className: string
};

export default MorningIcon;
